// src/components/InventarioCocina.jsx
import React, { useEffect, useState } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm"; // Importar el modal de confirmación
import ModalAgregarArticulo from "./ModalAgregarArticulo"; // Importar el nuevo modal para agregar artículos

const InventarioCocina = ({ cocinaId }) => {
    const [inventario, setInventario] = useState([]);
    const [mostrarInventario, setMostrarInventario] = useState(false); // Controla la visibilidad del inventario
    const [busqueda, setBusqueda] = useState(""); // Controla la barra de búsqueda
    const [articuloSeleccionado, setArticuloSeleccionado] = useState(null); // Para almacenar el artículo seleccionado
    const [editandoArticulo, setEditandoArticulo] = useState(null); // Controla la edición de artículos
    const [showConfirmModal, setShowConfirmModal] = useState(false); // Para el modal de confirmación
    const [nuevoArticulo, setNuevoArticulo] = useState({ nombre_articulo: "", cantidad: "", unidad: "" }); // Para agregar nuevo artículo
    const [agregarArticulo, setAgregarArticulo] = useState(false); // Controla la visibilidad del formulario para agregar artículos
    const [showAgregarArticuloModal, setShowAgregarArticuloModal] = useState(false); // Controla la visibilidad del modal de agregar artículo
    const [nombreCocina, setNombreCocina] = useState(""); // Estado para almacenar el nombre de la cocina

    // Función para obtener los datos de la cocina usando el cocinaId
    const obtenerCocina = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "cocinas"
            });

            const cocina = response.data.data[0].find(item => item.id === cocinaId);
            if (cocina) {
                setNombreCocina(cocina.nombre); // Almacenar el nombre de la cocina
            }
        } catch (error) {
            console.log(error);
        }
    };

    // Obtener inventario de la cocina
    const obtenerInventario = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "inventario_cocina"
            });            
            setInventario(response.data.data[0]); // Guardar el inventario completo
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {        
        obtenerCocina(); // Llamamos la función para obtener los detalles de la cocina
        obtenerInventario();  // Llamamos la función para obtener el inventario
    }, [cocinaId]);


    // Función para filtrar el inventario por cocina_id
    const filtrarInventarioPorCocina = (cocinaId) => {
        return inventario.filter(item => item.cocina_id === cocinaId);
    };

    // Función para manejar la búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    // Función para filtrar el inventario con la barra de búsqueda
    const inventarioFiltrado = filtrarInventarioPorCocina(cocinaId);    


    // Función para manejar la edición de un artículo
    const editarArticulo = (articulo) => {
        setEditandoArticulo(articulo);
    };

    // Función para guardar los cambios del artículo editado
    const guardarArticuloEditado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "inventario_cocina",
                id: editandoArticulo.id,
                cocina_id: editandoArticulo.cocina_id,
                nombre_articulo: editandoArticulo.nombre_articulo,
                cantidad: editandoArticulo.cantidad,
                unidad: editandoArticulo.unidad
            });
            setEditandoArticulo(null);
            obtenerInventario(); // Actualizar el inventario después de guardar
        } catch (error) {
            console.log(error);
        }
    };

    // Función para eliminar un artículo del inventario
    const confirmarEliminarArticulo = (articulo) => {
        setArticuloSeleccionado(articulo);
        setShowConfirmModal(true); // Mostrar el modal de confirmación
    };

    const eliminarArticulo = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "inventario_cocina",
                id: articuloSeleccionado.id
            });
            setShowConfirmModal(false); // Cerrar el modal de confirmación
            obtenerInventario(); // Actualizar el inventario después de eliminar
        } catch (error) {
            console.log(error);
        }
    };

    // Función para manejar el abrir/cerrar del modal de agregar artículo
    const handleAbrirAgregarArticuloModal = () => {
        setShowAgregarArticuloModal(true);
    };

    const handleCerrarAgregarArticuloModal = () => {
        setShowAgregarArticuloModal(false);
    };

    return (
        <div>
            
            {/* Mostrar inventario si el botón ha sido presionado */}
                <div className="mt-4 border p-4 rounded-lg">
                    <h3 className="text-lg font-semibold">Inventario de la Cocina: {nombreCocina}</h3>
                    {/* Barra de búsqueda */}
                    <input
                        type="text"
                        placeholder="Buscar artículo..."
                        value={busqueda}
                        onChange={handleBusqueda}
                        className="border rounded-lg p-2 mb-4 mt-2 w-1/2 min-w-[200px]"
                    />

                    {/* Botón para abrir el modal de agregar artículo */}
                    <button
                        onClick={handleAbrirAgregarArticuloModal}
                        className="bg-blue-500 text-white rounded px-4 py-2 mt-4 ml-6 hover:bg-blue-400"
                    >
                        Agregar Nuevo Artículo
                    </button>

                    <ul>
                        {inventarioFiltrado.map((item) => (
                            <li key={item.id} className="border p-2 mb-2 mt-4">
                                {editandoArticulo && editandoArticulo.id === item.id ? (
                                    <>
                                     <div className="flex flex-col">
                                     <h3 className=" font-semibold mt-2">Artículo:</h3>
                                        <input
                                            type="text"
                                            value={editandoArticulo.nombre_articulo}
                                            onChange={(e) =>
                                                setEditandoArticulo({ ...editandoArticulo, nombre_articulo: e.target.value })
                                            }
                                            className="border rounded-lg p-2 mr-2"
                                            maxLength={30}
                                        />
                                        <h3 className=" font-semibold mt-2">Cantidad:</h3>
                                        <input
                                            type="number"
                                            value={editandoArticulo.cantidad}
                                            onChange={(e) =>
                                                setEditandoArticulo({ ...editandoArticulo, cantidad: e.target.value })
                                            }
                                            className="border rounded-lg p-2 mr-2"
                                            maxLength={10}
                                        />
                                        <h3 className=" font-semibold mt-2">Unidad:</h3>
                                        <input
                                            type="text"
                                            value={editandoArticulo.unidad}
                                            onChange={(e) =>
                                                setEditandoArticulo({ ...editandoArticulo, unidad: e.target.value })
                                            }
                                            className="border rounded-lg p-2 mr-2"
                                            maxLength={10}
                                        />
                                        <div className="flex mt-4 mb-2">
                                        <button
                                            onClick={guardarArticuloEditado}
                                            className="bg-green-500 text-white rounded px-2 py-1 mt-2 w-40"
                                        >
                                            Guardar
                                        </button>
                                        <button
                                            onClick={() => setEditandoArticulo(null)}
                                            className="bg-gray-500 text-white rounded px-2 py-1 mt-2 ml-2 w-40"
                                        >
                                            Cancelar
                                        </button>
                                        </div>
                                        </div>
                                    </>
                                    
                                ) : (
                                    <>
                                        <span><strong>Artículo:</strong> {item.nombre_articulo}</span><br />
                                        <span><strong>Cantidad:</strong> {item.cantidad} {item.unidad}</span><br />
                                        <span><strong>Última Actualización:</strong> {item.ultima_actualizacion || "No disponible"}</span><br />
                                        <button
                                            onClick={() => editarArticulo(item)}
                                            className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400"
                                        >
                                            Editar
                                        </button>
                                        <button
                                            onClick={() => confirmarEliminarArticulo(item)}
                                            className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                        >
                                            Eliminar
                                        </button>
                                        
                                    </>
                                    
                                )}
                            </li>
                        ))}
                    </ul>

                </div>
           
            {/* Modal de confirmación */}
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este artículo?"
                onConfirm={eliminarArticulo}
                onCancel={() => setShowConfirmModal(false)}
            />

            {/* Modal para agregar un nuevo artículo */}
            <ModalAgregarArticulo
                show={showAgregarArticuloModal}
                onClose={handleCerrarAgregarArticuloModal}
                cocinaId={cocinaId}
                onArticuloAgregado={obtenerInventario} // Actualiza el inventario tras agregar un nuevo artículo
            />
        </div>
    );
};

export default InventarioCocina;
